'use strict';
/* eslint-disable */

/**
 * OG.setProduct should be called when the page loads or when the user selects a different product.
 */
function setProduct() {
	if (window.OG && window.OG.setProduct) {
		var productID = $('.og-offer').data('og-product');
		var productCount = $('.pdpForm .input-group-qty').val();
		window.OG.setProduct({
			id: productID,
			module: 'pdp',
			quantity: productCount
		});
	}
}

/**
 * Informs OG a product quantity has changed
 */
function setQuantity() {
	var productID = $('.og-offer').data('og-product');
	var productCount = $('.pdpForm .input-group-qty').val();
	window.OG.setQuantity({
		id: productID,
		quantity: productCount,
		module: 'pdp'
	});
}

/**
 * Informs OG a product is added to the cart
 */
function addToCart($form) {
	var $localForm = $form || $('form.pdpForm');
	var productID = $localForm.find('.og-offer').data('og-product');
	var productCount = $localForm.find('.input-group-qty').val();
	window.OG.addToCart([
		{
			id: productID,
			quantity: productCount,
			module: 'pdp'
		}
	]);
}

module.exports = {
		setProduct: setProduct,
		setQuantity: setQuantity,
		addToCart: addToCart
};
